<template>
  <div class="experimentalCenter">
    <div class="experimentalCenter-title">
      <div class="experimentalCenter-title-search">
        <el-input placeholder="请输入搜索内容" prefix-icon="el-icon-search" v-model="searchInput" @blur="queryAllExperiment"
          @keyup.native.enter="queryAllExperiment">
        </el-input>
      </div>
      <div class="experimentalCenter-title-sort">
        <span>学科分类：</span>
        <div class="sort-list">
          <div class="list" v-for="item in subjectList.tag" :class="IDList.tagId == item.id ? 'list-active' : ''"
            :key="item.id" @click="clickSerarch('tagId', item.id)">
            <span>{{ item.name }}</span><i>({{ item.num }})</i>
          </div>
        </div>
      </div>
      <div class="experimentalCenter-title-sort">
        <span>课程认定：</span>
        <div class="sort-list">
          <div class="list" v-for="item in subjectList.level" :class="IDList.level == item.id ? 'list-active' : ''"
            :key="item.id" @click="clickSerarch('level', item.id)">
            <span>{{ item.name }}</span><i>({{ item.num }})</i>
          </div>
        </div>
      </div>
    </div>
    <div class="experimentalCenter-container" v-if="experimentList && experimentList.length > 0">
      <div class="card" v-for="item in experimentList" :key="item.id">
        <experimentCard :detail="item"></experimentCard>
      </div>
    </div>
    <noDate v-else :tip="'暂无实验'" style="padding-top:120px;padding-bottom:150px"></noDate>
    <el-pagination v-if="experimentList && experimentList.length > 0" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[8, 12, 16, 20, 24]" :page-size="8"
      layout="total, sizes, prev, pager, next, jumper" :total="totalItems">
    </el-pagination>
  </div>
</template>

<script>
import experimentCard from "@/components/experimentCard.vue";
import noDate from "@/components/common/noData.vue";
export default {
  name: "VirtualimitationIndex",
  components: { experimentCard, noDate },
  data () {
    return {
      IDList: { tagId: -1, collegeId: -1, level: -1 },
      subjectList: {
        college: [],
        level: [],
        tag: [],
      }, //实验类别
      level: "", //评级认定
      searchInput: "",
      currentPage: 1,
      params: {
        collegeId: 0,
        level: 0, //等级认定
        name: "",
        pageIndex: 1,
        showItem: 8,
        status: 0, //我的实验，0 待学习 1 已完成 2 收藏
        tagId: 0, //学科分类
      },
      experimentList: null,
      totalItems: 0,
    };
  },

  mounted () {
    this.getExperimentKinds();
    this.queryAllExperiment();
    setTimeout(() => {
      let userInfo = localStorage.getItem('USER')
      if (!userInfo) {
        this.$message.warning('请您先登录！')
        this.$router.push("/login");
      }
    }, 1000);
  },

  methods: {
    //搜索实验
    queryAllExperiment () {
      this.params.name = this.searchInput.trim();
      this.$api.experiment.queryAllExperiment(this.params).then((res) => {
        if (res.data != null && res.errCode == 0) {
          this.experimentList = res.data.items;
          this.totalItems = res.data.totalItems;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    clickSerarch (type, id) {
      // this.params.collegeId = 0;
      // this.params.level = 0;
      // this.params.tagId = 0;
      this.params[type] = id;
      this.IDList[type] = id;
      // this.active = type + "" + id;
      this.queryAllExperiment();
    },
    //获取学科类别
    getExperimentKinds () {
      this.$api.experiment.getExperimentKinds().then((res) => {
        if (res.data != null && res.errCode == 0) {
          this.subjectList = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    handleSizeChange (val) {
      this.params.pageIndex = 1;
      this.params.showItem = val;
      this.queryAllExperiment();
    },
    handleCurrentChange (val) {
      this.params.pageIndex = val;
      this.queryAllExperiment();
    },
  },
};
</script>

<style lang="less" scoped>
.experimentalCenter {
  width: 100%;

  .experimentalCenter-title {
    width: 100%;
    background: #fff;
    padding: 34px 51px;
    box-sizing: border-box;

    .experimentalCenter-title-sort {
      display: flex;
      justify-content: start;
      //   margin-bottom: 41px;
      padding-top: 19px;
      padding-bottom: 19px;
      border-bottom: 1px solid #eef2fa;

      .sort-list {
        display: flex;
        justify-content: start;
        margin-left: 23px;
        flex-wrap: wrap;

        .list {
          margin-right: 20px;
          cursor: pointer;

          &:hover {

            span,
            i {
              color: #1880fa !important;
            }
          }

          span,
          i {
            width: 1228px;
            height: 50px;
            font-size: 14px;
            font-family: PingFang-SC;
            font-weight: 400;
            line-height: 30px;
            color: #898989;
            opacity: 1;
            font-style: normal;
          }

          span {
            color: #101012;
          }
        }
      }

      &>span {
        display: block;
        width: 70px;
        height: 20px;
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 400;
        color: #99a7c3;
        opacity: 1;
        flex-shrink: 0;
        line-height: 30px;
      }
    }

    .experimentalCenter-title-course {
      display: flex;
      justify-content: start;

      &>span {
        display: block;
        width: 70px;
        height: 20px;
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 20px;
        color: #99a7c3;
        opacity: 1;
        margin-right: 23px;
      }

      .el-select {
        width: 103px;
      }
    }

    .experimentalCenter-title-search {
      width: 604px;
      height: 42px;
      margin: 0 auto;

      .el-input {
        width: 604px;
      }
    }
  }

  .experimentalCenter-container {
    margin-top: 16px;
    display: flex;
    justify-content: start;
    flex-wrap: wrap;

    .card {
      margin-right: 10px;
      margin-bottom: 18px;

      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }

  .el-pagination {
    text-align: center;
    margin-top: 45px;
    margin-bottom: 16px;
  }
}

.list-active {

  span,
  i {
    color: #1880fa !important;
  }
}
</style>